import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Button, useTheme, Text } from 'react-native-paper';
import EmailSvg from '@@icons/ic-mail-dt.svg';
import { WebContainer } from '~components/webContainer';
import BrandBackground from '~components/brandBackground';

export const PasswordResetEmailSuccess = ({ navigation }) => {
	const theme = useTheme();
	const insets = useSafeAreaInsets();
	const styles = StyleSheet.create({
		outerView: {
			flex: 1,
			backgroundColor: theme.colors.background,
			justifyContent: 'center',
			paddingTop: insets.top
		},
		innerView: {
			paddingHorizontal: '5%',
			marginTop: '4%',
			alignItems: 'center'
		},
		title: { fontSize: 24, marginVertical: 25 },
		caption: { fontSize: 18, marginVertical: 25 },
		submitButton: {
			marginTop: 15,
			marginBottom: 15
		},
		submitButtonText: {
			fontSize: 18,
			padding: 5
		},
		titleWeb: {
			fontSize: 24,
			marginVertical: 25,
			textAlign: 'center'
		}
	});

	return <>{Platform.OS === 'web' ? WebView() : MobileView()}</>;

	function WebView() {
		return (
			<BrandBackground>
				<WebContainer size="sm">
					<View style={styles.innerView}>
						<EmailSvg
							fill={theme.colors.primary}
							highlight={theme.colors.primary}
							width={100}
							height={100}
						/>
						
						<Text variant="titleLarge" style={styles.titleWeb}>
							Password Reset Email Sent
						</Text>
						<Text variant="bodySmall" style={styles.caption}>
							Check your email and follow the link provided to complete the
							password reset process.
						</Text>

						<Button
							mode="text"
							compact={true}
							onPress={() => {
								navigation.push('Login');
							}}
							style={styles.submitButton}
							labelStyle={styles.submitButtonText}
							uppercase={false}
						>
							Back to Log In Screen
						</Button>
					</View>
				</WebContainer>
			</BrandBackground>
		);
	}

	function MobileView() {
		return (
			<View style={styles.outerView}>
				<View style={styles.innerView}>
					{/* <EmailSvg
					fill={theme.colors.primary}
					highlight={theme.colors.primary}
					width={100}
					height={100}
					marginBottom={'5%'}
				/> */}
					<Text variant="titleLarge" style={styles.title}>Password Reset Email Sent</Text>
					<Text variant="bodySmall" style={styles.caption}>
						Check your email and follow the link provided to complete the
						password reset process.
					</Text>

					<Button
						mode="text"
						compact={true}
						onPress={() => {
							navigation.push('Login');
						}}
						style={styles.submitButton}
						labelStyle={styles.submitButtonText}
						uppercase={false}
					>
						Back to Log In Screen
					</Button>
				</View>
			</View>
		);
	}
};
